module.exports = __webpack_public_path__ + "img/search-empty.8e79174d.png";